import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  timer: {
    maxWidth: 160,
  },
  timerText: {
    backgroundColor: 'transparent',
    color: '#FFF',
    fontSize: 11,
  },
});
